import type { CampaignSendStats } from '../types/campaign-send-stats';
import type { CampaignStats, ReportCampaignRow } from '../types/reports.types';

export function toCampaignStats(doc: CampaignSendStats): CampaignStats {
  const skipTotal = doc.SkipTotal ?? 0;
  return {
    audience: doc.Audience,
    sent: doc.Sent,
    delivered: doc.Delivered,
    bounced: doc.Bounced,
    bouncedHard: doc.BouncedHard,
    bouncedSoft: doc.BouncedSoft,
    uniqueOpens: doc.UniqueOpens,
    uniqueClicks: doc.UniqueClicks,
    complaints: doc.Complaints,
    unsubscribes: doc.Unsubscribes,
    skipTotal,
    sendableCount: doc.Audience - skipTotal,
    balances: doc.Sent + skipTotal === doc.Audience,
    computedAt: doc.ComputedAt,
  };
}

export function toReportCampaignRow(doc: CampaignSendStats): ReportCampaignRow {
  return {
    campaignId: doc.CampaignId,
    name: doc.Name,
    status: doc.Status,
    sentAt: doc.SentAt,
    stats: toCampaignStats(doc),
  };
}
